module.exports = __webpack_public_path__ + "img/teamMember5.11bcfaf6.png";